import { addToCart } from '../utils/addToCart';

export default class AddToCartButton extends HTMLElement {
  private button: HTMLButtonElement | null = null;
  private variantId: string | null = null;
  private isGiftCard = false;
  private onClickBound = this.onClick.bind(this);

  connectedCallback(): void {
    this.button = this.querySelector('[data-add-to-cart-button-ref="button"]');
    this.variantId = this.getAttribute('data-variant-id');
    this.isGiftCard = this.getAttribute('data-gift-card') === 'true';

    this.addEventListeners();
  }

  addEventListeners(): void {
    if (this.button) {
      this.button.addEventListener('click', this.onClickBound);
    }
  }

  removeEventListeners(): void {
    if (this.button) {
      this.button.removeEventListener('click', this.onClickBound);
    }
  }

  onClick(): void {
    if (!this.variantId) {
      return;
    }

    addToCart({
      id: this.variantId,
      quantity: 1,
      gift_card: this.isGiftCard,
      ...(this.getAttribute('data-offer-free-gift') === 'true'
        ? { properties: { _offer_free_gift: '1' } }
        : {}),
    });
  }

  disconnectedCallback(): void {
    this.removeEventListeners();
  }
}

customElements.define('add-to-cart-button', AddToCartButton);
